import { calendarDayString, instantTenantDay } from '../../lib/calendar-date';

/**
 * The Bills of Lading CSV, as text.
 *
 * `signed_at` is an INSTANT — the moment the customer signed — so its day is
 * the TENANT's day, not UTC's. It used to export `signed_at?.slice(0, 10)`,
 * the UTC day, so a signature after 18:00 MDT (17:00 MST) printed as
 * tomorrow, and the API's Postgres spelling made that a textual cut of
 * whatever offset the server happened to write. `scheduled_date` is a `date`
 * column and stays a calendar day as stored.
 *
 * Pulled out of the screen so the zone can be tested without rendering it.
 *
 * Hours is `billable_hours`, the key GET /trucking/loads/bols sends. It read
 * `hours`, which the route has never sent, so the column was always empty.
 */
export function buildBolCsv(bols: any[], timeZone: string): string {
  const headers = ['BOL Number', 'Status', 'Scheduled Date', 'Truck', 'Driver', 'Customer', 'Delivery Location', 'Billing Type', 'Flat Rate', 'Hours', 'KM Driven', 'Signed At'];
  const escape = (v: any) => {
    const s = v == null ? '' : String(v);
    return s.includes(',') || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const signedOn = (v: unknown) => instantTenantDay(v, timeZone) ?? '';
  const rows = bols.map((b: any) => [
    b.bol_number, b.status, calendarDayString(b.scheduled_date) ?? '', b.truck_unit_number ?? '',
    b.driver_name ?? '', b.customer_name ?? '', b.delivery_location ?? '', b.billing_type ?? '',
    b.flat_haul_rate ?? '', b.billable_hours ?? '', b.km_driven ?? '', signedOn(b.signed_at),
  ].map(escape).join(','));
  return [headers.join(','), ...rows].join('\n');
}
